import { formatDateToSubmitValue, getToAt, } from '@/feature/hotline/util/formatDate';
/**
 * form の値を送信用の値に変換する
 */
export const getHotlineScheduleSubmitValues = (formValue) => {
    const { interviewTime, interviewedFromAt } = formValue;
    return {
        interviewed_from_at: formatDateToSubmitValue(interviewedFromAt),
        interviewed_to_at: formatDateToSubmitValue(getToAt(interviewedFromAt, interviewTime)),
    };
};
